/**
 *
 * TasksPageContainer
 *
 * 
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import queryString from 'query-string';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';

import { makeSelectRoles, makeSelectAccountId } from 'domain/User/selectors';
import { makeSelectBreakpoint } from 'domain/Screen/selectors';

import getTasksPage from './getTasksPage';
import saga from './sagas';

export class TasksPageContainer extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function
  render() {
    const { accountId, userRoles, match: { params }, ...restProps } = this.props;
    const { view: viewName = 'alltasks' } = queryString.parse(this.props.location.search);
    const props = { viewName, userRoles, params, ...restProps,accountId };

    return getTasksPage(props);
  }
}

TasksPageContainer.propTypes = {
  location: PropTypes.object.isRequired,
  accountId: PropTypes.string,
  userRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  match: PropTypes.object,
};

const mapStateToProps = createStructuredSelector({
  accountId: makeSelectAccountId(),
  userRoles: makeSelectRoles(),
  breakpoint: makeSelectBreakpoint(),
});

const reducer = (state = {}) => state;
const withReducer = injectReducer({ key: 'taskPage', reducer });
const withSaga = injectSaga({ key: 'taskPage', saga });
const withConnect = connect(mapStateToProps);

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(TasksPageContainer);
